/**
 * @generated SignedSource<<9e257d193fcd3a900060e915482cfc02>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DiscardNovaConversationInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DiscardNovaConversationMutation$variables = {
  input: DiscardNovaConversationInput;
};
export type DiscardNovaConversationMutation$data = {
  readonly discardNovaConversation: {
    readonly run: {
      readonly id: string;
      readonly discarded: boolean | null;
    } | null;
    readonly task: {
      readonly id: string;
      readonly hasNovaConversation: boolean;
      readonly novaThread: ReadonlyArray<{
        readonly id: string;
      }>;
    } | null;
  } | null;
};
export type DiscardNovaConversationMutation = {
  variables: DiscardNovaConversationMutation$variables;
  response: DiscardNovaConversationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DiscardNovaConversationPayload",
    "kind": "LinkedField",
    "name": "discardNovaConversation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NovaAgentRun",
        "kind": "LinkedField",
        "name": "run",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "discarded",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "task",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasNovaConversation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaAgentRun",
            "kind": "LinkedField",
            "name": "novaThread",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiscardNovaConversationMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiscardNovaConversationMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2e1661418d41a915cb6257b16ed00992",
    "id": null,
    "metadata": {},
    "name": "DiscardNovaConversationMutation",
    "operationKind": "mutation",
    "text": "mutation DiscardNovaConversationMutation(\n  $input: DiscardNovaConversationInput!\n) {\n  discardNovaConversation(input: $input) {\n    run {\n      id\n      discarded\n    }\n    task {\n      id\n      hasNovaConversation\n      novaThread {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "226dd5a6f01795aff5bea31f8496b380";

export default node;
